import React, { useState } from 'react';
import { getGradeLabel } from '../utils/gradeUtils';
import PinAuth from './PinAuth';

/**
 * ログイン直後のプロフィール選択画面（フルスクリーン）
 * children: プロフィール一覧
 * onSelect(child): 選択完了コールバック
 */
export default function ProfileLogin({ children, onSelect, onManage, onBack }) {
  const [pinTarget, setPinTarget] = useState(null);

  const handleTap = (child) => {
    if (child.pin) {
      setPinTarget(child);
    } else {
      onSelect(child);
    }
  };

  // PIN認証画面
  if (pinTarget) {
    return (
      <div className="profile-login-screen">
        <PinAuth
          correctPin={pinTarget.pin}
          childName={pinTarget.name}
          childAvatar={pinTarget.avatar}
          onSuccess={() => onSelect(pinTarget)}
          onCancel={() => setPinTarget(null)}
        />
      </div>
    );
  }

  return (
    <div className="profile-login-screen">

      {onBack && (
        <button
          onClick={onBack}
          style={{ alignSelf: 'flex-start', background: 'none', border: 'none', color: 'rgba(255,255,255,0.7)', fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', marginBottom: 8 }}
        >← もどる</button>
      )}

      <div className="profile-login-header">
        <div className="v9-logo-sub" style={{ color: '#C4B5FD' }}>READING APP</div>
        <div className="v9-logo-main" style={{ color: 'white' }}>
          Ondoku <span>Quest</span>
        </div>
      </div>

      <div className="profile-login-title">だれが　つかう？</div>

      <div className="profile-login-list">
        {children.map((child) => {
          const grade = (child.birth_year && child.birth_month)
            ? getGradeLabel(child.birth_year, child.birth_month)
            : '';
          return (
            <button
              key={child.id}
              className="profile-login-card"
              onClick={() => handleTap(child)}
            >
              <span className="profile-login-avatar">{child.avatar || '🐣'}</span>
              <span className="profile-login-name">{child.name || 'ゲスト'}</span>
              {grade && <span className="profile-login-grade">{grade}</span>}
              {child.pin && <span className="profile-login-lock">🔒</span>}
            </button>
          );
        })}
      </div>

      {/* 目立たない管理リンク */}
      {onManage && (
        <button
          onClick={onManage}
          style={{ marginTop: 'auto', paddingTop: 40, background: 'none', border: 'none', color: 'rgba(255,255,255,0.35)', fontSize: 12, cursor: 'pointer', fontFamily: 'inherit' }}
        >
          ⚙️ プロフィールの管理
        </button>
      )}

    </div>
  );
}
